module.exports = __webpack_public_path__ + "img/login01a.e681da53.png";